import {
  Component,
  Input,
  Output,
  EventEmitter,
  HostListener,
  OnInit,
} from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';

interface user {
  name: string;
  avatar: string;
  title_job: string;
}

@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  styleUrl: './topbar.component.scss',
})
export class TopbarComponent implements OnInit {
  @Input() user: user = {
    name: 'David',
    avatar: 'DK',
    title_job: 'Web Developer',
  };
  @Input() isCollapsed: boolean = false;
  @Input() chatCount: number = 5;
  @Input() notificationCount: number = 21;
  @Output() toggleCollapse = new EventEmitter<boolean>();
  @Output() goToUserProfile = new EventEmitter<void>();

  constructor(public auth: AuthService) {}

  ngOnInit(): void {
    this.checkScroll();
  }

  @HostListener('window:scroll', [])
  onWindowScroll(): void {
    this.checkScroll();
  }

  checkScroll(): void {
    const header = document.querySelector('.header');
    if (header) {
      if (window.pageYOffset > 0) {
        header.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
      }
    }
  }

  toggle() {
    this.isCollapsed = !this.isCollapsed;
    this.toggleCollapse.emit(this.isCollapsed);
  }

  onGoToUserProfile() {
    this.goToUserProfile.emit();
  }

  onLogout() {
    this.auth.logout();
  }
}
